export default __webpack_public_path__ + "static/media/blog-img241.2a1df1a9.jpg";